// export const PBIUrlAPI = "http://bi-api.volpelab.com.br/";
export const PBIUrlAPI = "https://apibi-volpelab.pwi.com.br/";
// export const PBIUrlAPI = "http://localhost:3105/";
export const URL = {
  URLLogin: "/login",
  URLCadastrarSenha: "/cadastrarsenha",
  URLRecuperarSenha: "/recuperarsenha",
  URLPrimeiroLogin: "/primeirologin",
  URLDashboardMensal: "/dashboardmensal",
  URLDashboardAtual: "/dashboardatual",
  URLRetornarFiltroDashboard: "/RetornarFiltroDashboard",
};
